import { render, staticRenderFns } from "./SummernoteEditor.vue?vue&type=template&id=5121f9c8&"
import script from "./SummernoteEditor.vue?vue&type=script&lang=js&"
export * from "./SummernoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SummernoteEditor.vue?vue&type=custom&index=0&blockType=link&href=%2Fsummernote-0.9.0-dist%2Fsummernote-bs4.css&rel=stylesheet"
if (typeof block0 === 'function') block0(component)

export default component.exports